import { useEffect, useRef } from 'react';

const PreviewEmailHtml = ({ html, height = 600, mode = 'desktop' }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (!iframeRef.current || !html) return;

    const iframe = iframeRef.current;
    const doc = iframe.contentDocument || iframe.contentWindow.document;

    // Write HTML into the iframe
    doc.open();
    doc.write(html);
    doc.close();
  }, [html]);

  const scale = mode === 'mobile' ? 0.55 : 1;
  const containerWidth = mode === 'mobile' ? 390 : '100%';

  return (
    <div
      style={{
        width: containerWidth,
        transform: `scale(${scale})`,
        transformOrigin: 'top left',
        border: '1px solid #ddd',
        borderRadius: 6,
        overflow: 'hidden',
        background: '#fff',
      }}
    >
      {html ? (
        <iframe
          ref={iframeRef}
          title="Email Preview"
          style={{
            width: '100%',
            height,
            border: 'none',
          }}
        />
      ) : (
        <div style={{ padding: 20, textAlign: 'center', color: '#666' }}>
          No preview available
        </div>
      )}
    </div>
  );
};

export default PreviewEmailHtml;
